import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'stateless-text-toggle',
  templateUrl: './stateless-text-toggle.component.html',
  styleUrls: ['./stateless-text-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatelessTextToggleComponent {
  @Input()
  showLabel: string = '';

  @Input()
  hideLabel: string = '';

  @Input()
  colorToken: string = '';

  get color(): string {
    return `var(${this.colorToken})`;
  }

  @Input()
  open: boolean = false;

  @Output()
  openChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  toggleOpen() {
    this.open = !this.open;
    this.openChange.emit(this.open);
  }

  @Input()
  chevronPosition: 'left' | 'right' = 'left';

  @Input()
  toggleSize: 'small' | 'default' = 'default';

  get iconSize(): 8 | 12 | 16 | 20 | 24 {
    return this.toggleSize === 'small' ? 16 : 20;
  }
}
